import React, { useState } from 'react';
import './searchTalentsFilter.css';
import { filterIcon } from '../../../../../utils/icons';
import { regiones, comunasSantiago } from '../../../../../helpers/locations/locationsOptions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-solid-svg-icons';

const SearchTalentsFilter = ({ handleSearchFilter }) => {
    const [filters, setFilters] = useState({
        position: '',
        experience: '',
        location: '',
        region: '',
        comuna: '',
        available: '',
        schedule: '',
    });

    const [showFilters, setShowFilters] = useState(false);
    
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters((prevFilters) => ({
            ...prevFilters,
            [name]: value,
        }));
    };

    const toggleFilters = () => {
        setShowFilters((prevShow) => !prevShow);
    };

    return (
        <div>
            <div className="search-talents-filter__container">
                <div className={`search-talents-filter__inputs-container ${showFilters ? 'show' : ''}`}>
                    <div className="search-talents-filter__select-container">
                        <select
                            id="position"
                            name="position"
                            value={filters.position}
                            onChange={handleChange}
                            className="search-talents-filter__select-input"
                        >
                            <option value="">Posición</option>
                            <option value="Garzón">Garzón</option>
                            <option value="Runner">Runner</option>
                            <option value="Chef">Chef</option>
                            <option value="Ayudante de Cocina">Ayudante de Cocina</option>
                            <option value="Anfitrión">Anfitrión</option>
                            <option value="Delivery">Delivery</option>
                            <option value="Cajero">Cajero</option>
                            <option value="Copero">Copero</option>
                            <option value="Barista">Barista</option>
                            <option value="Bartender">Bartender</option>
                            <option value="Sommelier">Sommelier</option>
                            <option value="Maitre">Maitre</option>
                            <option value="Jefe de salón">Jefe de salón</option>
                            <option value="Limpieza">Limpieza</option>
                            <option value="Chef Ejecutivo">Chef Ejecutivo</option>
                            <option value="Sous Chef">Sous Chef</option>
                            <option value="Jefe de Cocina">Jefe de Cocina</option>
                            <option value="Maestro de Cocina">Maestro de Cocina</option>
                            <option value="Maestro Pastelero">Maestro Pastelero</option>
                            <option value="Pastelero">Pastelero</option>
                            <option value="Panadero">Panadero</option>
                            <option value="Repostero">Repostero</option>
                            <option value="Charcutero">Charcutero</option>
                            <option value="Pizzero">Pizzero</option>
                            <option value="Itamae">Itamae</option>
                            <option value="Sushiman">Sushiman</option>
                            <option value="Ayudante de Sushi">Ayudante de Sushi</option>
                            <option value="Parrillero">Parrillero</option>
                            <option value="Cocinero Frío">Cocinero Frío</option>
                            <option value="Cocinero Caliente">Cocinero Caliente</option>
                            <option value="Manipulador de Alimentos">Manipulador de Alimentos</option>
                            <option value="Encargado de Producción">Encargado de Producción</option>
                            <option value="Operador de Cocina">Operador de Cocina</option>
                            <option value="Operador de Planta">Operador de Planta</option>
                            <option value="Operador Multifuncional">Operador Multifuncional</option>
                            <option value="Encargado de Reservas">Encargado de Reservas</option>
                            <option value="Recepcionista de Restaurante">Recepcionista de Restaurante</option>
                            <option value="Supervisor de Salón">Supervisor de Salón</option>
                            <option value="Personal de Banquetería">Personal de Banquetería</option>
                            <option value="Encargado de Bodega">Encargado de Bodega</option>
                            <option value="Repositor">Repositor</option>
                            <option value="Personal de Mantenimiento">Personal de Mantenimiento</option>
                            <option value="Jefe de Local">Jefe de Local</option>
                            <option value="Administrador de Local">Administrador de Local</option>
                            <option value="Jefe de Sucursales">Jefe de Sucursales</option>
                            <option value="Administrador de Restaurante">Administrador de Restaurante</option>
                            <option value="Encargado de Compras">Encargado de Compras</option>
                            <option value="Control de Calidad">Control de Calidad</option>
                            <option value="Catador de Vinos">Catador de Vinos</option>
                            <option value="Coordinador de Banquetes">Coordinador de Banquetes</option>
                            <option value="Montajista">Montajista</option>
                            <option value="Mixólogo">Mixólogo</option>
                        </select>
                    </div>
                    <div>
                        <select
                            id="experience"
                            name="experience"
                            value={filters.experience}
                            onChange={handleChange}
                            className="search-talents-filter__select-input"
                        >
                            <option value="">Experiencia</option>
                            <option value="1 año">1 año</option>
                            <option value="2 años">2 años</option>
                            <option value="3 años">3 años</option>
                            <option value="4 años">4 años</option>
                            <option value="Más de 5 años">Más de 5 años</option>
                        </select>
                    </div>

                    <div>
                        <select
                            id="region"
                            name="region"
                            value={filters.region}
                            onChange={handleChange}
                            className="search-talents-filter__select-input"
                        >
                            <option value="">Región</option>
                            {regiones.map((region, index) => (
                                <option key={index} value={region}>{region}</option>
                            ))}
                        </select>
                    </div>

                    <div>
                        <select
                            id="comuna"
                            name="comuna"
                            value={filters.comuna}
                            onChange={handleChange}
                            className="search-talents-filter__select-input"
                        >
                            <option value="">Comuna</option>
                            {comunasSantiago.map((region, index) => (
                                <option key={index} value={region}>{region}</option>
                            ))}
                        </select>
                    </div>

                    <div>
                        <select
                            id="available"
                            name="available"
                            value={filters.available}
                            onChange={handleChange}
                            className="search-talents-filter__select-input"
                        >
                            <option value="">Disponibilidad</option>
                            <option value="Inmediata">Inmediata</option>
                            <option value="Programada">Programada</option>
                        </select>
                    </div>

                    <div>
                        <select
                            id="schedule"
                            name="schedule"
                            value={filters.schedule}
                            onChange={handleChange}
                            className="search-talents-filter__select-input"
                        >
                            <option value="">Jornada</option>
                            <option value="Tiempo parcial">Tiempo parcial</option>
                            <option value="Tiempo completo">Tiempo completo</option>
                        </select>
                    </div>

                    <button onClick={() => handleSearchFilter(filters)} className="search-talents-filter__button">
                        <FontAwesomeIcon icon={faSearch} />
                    </button>
                </div>

                <div className="search-talents-filter__filter-container" onClick={toggleFilters}>
                    {filterIcon}
                </div>
            </div>
        </div>
    );
};

export default SearchTalentsFilter;


